import * as angular from "angular";
import { JavaApiAdapterService } from "@common/apiadapter/javaapi.service";
import { CacheService } from "@common/service/cache.service";

export interface IEventLocation {
    id: string;
    name: string;
}

export interface IEventLocationService {
    getEventLocations(): ng.IPromise<IEventLocation[]>;
    getEventLocationNames(locationId: string): ng.IPromise<string>;
}

export class EventLocationService implements IEventLocationService {
    static $inject = ["$q", "CacheService", "ApiAdapterService"];

    constructor(
        private $q: ng.IQService,
        private $_cache: CacheService,
        private $_api: JavaApiAdapterService
    ) {}

    /**
     * Gets a sorted list of hard-coded event locations.
     */
    getEventLocations(): ng.IPromise<IEventLocation[]> {
        const eLocations: IEventLocation[] = [
            { id: "1", name: "Conference Room" },
            { id: "2", name: "Office - A" },
            { id: "3", name: "Room - B" },
            { id: "4", name: "Other" },
        ];

        eLocations.sort((a, b) =>
            a.name.toLowerCase().localeCompare(b.name.toLowerCase())
        );

        return this.$q.when(eLocations);
    }

    /**
     * Gets the name of a location by its ID.
     * @param locationId The ID of the location.
     */
    getEventLocationNames(locationId: string): ng.IPromise<string> {
        return this.getEventLocations().then((locations) => {
            const location = locations.find((loc) => loc.id === locationId);
            return location ? location.name : "";
        });
    }
}

angular
    .module("eCareVault.common.services")
    .service("EventLocationService", EventLocationService);
